import { atomWithStorage } from "jotai/utils";
import { IncomeEvent } from "../types";

/**
 * The dated income log — received payments and expected / invoiced income.
 * Persisted in localStorage until the cash-flow API is wired (see
 * functions/cashflowSync.ts and docs/CASHFLOW_API.md).
 */
export const incomeEventsAtom = atomWithStorage<IncomeEvent[]>(
  "cashflow.incomeEvents",
  [],
  undefined,
  { getOnInit: true },
);
